import { apiService } from "@/common/api.service.js";

export default {

//
// CAPACITY TOOL
//

// Nested Rated Capacities for Filtering
  nestedRatedCapacities() {
    let endpoint = `/api/nested-rated-capacities/`;
    return apiService(endpoint);
  },
  getCapacity(payload) {
    let endpoint = `/api/get-capacity/`;
    return apiService(endpoint, "POST", payload)
  },


}